import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { Box, Typography } from '@mui/material'

import { TownHallIcon } from '~assets/icons'
import { PreTextStreamResponseStep } from '~hooks/useStreamAIResponse'
import { EnrichedOrganizationAISettings } from '~types'

const stepMessages: Record<PreTextStreamResponseStep, string> = {
  initialization: 'This may take a moment',
  query_analysis: 'Analyzing your question',
  retrieval: 'Searching organization',
  gis_lookup: 'Searching geolocation data',
  generation: 'Generating response',
}

export const ChatStreamProgressBubble = ({
  step,
  orgAiSettings,
}: {
  step: PreTextStreamResponseStep
  orgAiSettings?: EnrichedOrganizationAISettings
}): JSX.Element => (
  <Box
    role='status'
    aria-label={stepMessages[step]}
    tabIndex={0}
    sx={{
      display: 'inline-flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      color: 'text.primary',
      borderRadius: 2,
      padding: 2,
      width: 240,
      boxShadow: 1,
      marginTop: 2,
      alignItems: 'center',
    }}
  >
    {/* Town Hall icon with Lottie magnifying glass overlay */}
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 1,
        width: 'fit-content',
        alignSelf: 'center',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <TownHallIcon width={40} height={40} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: -4,
          left: -4,
          right: -4,
          bottom: -4,
          zIndex: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <DotLottieReact
          src='https://lottie.host/8b9a70ba-9608-4e71-b8da-a3552841a82d/c7RJmpMaB4.lottie'
          loop
          autoplay
          style={{ width: '110%', height: '110%' }}
        />
      </Box>
    </Box>
    <Typography
      variant='body1'
      color='text.primary'
      fontFamily={orgAiSettings?.font_family || 'inherit'}
      sx={{ marginBottom: 1, alignSelf: 'center' }}
    >
      {stepMessages[step]}
    </Typography>
  </Box>
)
